import { i18n } from '@/locales';
const { t } = i18n;
const lc = 'views.worker.worker_baromoney_history.table_header.';
export const workerBaromoneyHistoryTableHeader = [
    {
        title: t(`${lc}worker_name`),
        value: 'formattedWorkerName',
        width: 200,
        fixed: true,
        align: 'center',
    },
    {
        title: t(`${lc}created_at`),
        value: 'formattedCreatedAt',
        width: 160,
        align: 'center',
    },
    {
        title: t(`${lc}hub_name`),
        value: 'formattedHubName',
        width: 200,
        align: 'center',
    },
    {
        title: t(`${lc}employee_type`),
        value: 'formattedEmployeeType',
        width: 170,
        align: 'center',
    },
    {
        title: t(`${lc}salary_type`),
        value: 'formattedSalaryType',
        width: 150,
        align: 'center',
    },
    {
        title: t(`${lc}hub_employee_number`),
        value: 'formattedHubEmployeeNumber',
        width: 120,
        align: 'center',
    },
    {
        title: t(`${lc}worker_code`),
        value: 'formattedWorkerCode',
        key: 'workerCode',
        sortable: true,
        width: 150,
        align: 'center',
    },
    {
        title: t(`${lc}content`),
        value: 'formattedContent',
        width: 350,
        align: 'center',
    },
    {
        title: t(`${lc}transaction_baromoney`),
        value: 'formattedTransactionBaromoney',
        width: 150,
        align: 'center',
    },
    {
        title: t(`${lc}balance_baromoney`),
        value: 'formattedBalanceBaromoney',
        align: 'center',
        width: 150,
    },
    {
        title: t(`${lc}order_id`),
        value: 'formattedOrderId',
        align: 'center',
        width: 120,
    },
    {
        title: t(`${lc}created_by`),
        value: 'formattedCreatedBy',
        align: 'center',
        width: 120,
    },
];
